export class TraceabilityStock {
  /** Site code */
  site: string

  /** Quantity (primary) */
  primaryQuantity: { value: string; unit: string }

  /** Quantity (secondary) */
  secondaryQuantity: { value: string; unit: string }

  constructor(stock: TraceabilityStock) {
    this.site = stock.site || ''
    this.primaryQuantity = stock.primaryQuantity || { value: '', unit: '' }
    this.secondaryQuantity = stock.secondaryQuantity || { value: '', unit: '' }
  }
}
